<template>
    <div>
        <v-chip outlined
                v-if="groupName"
                color="blue-grey"
                text-color="white">
            {{ groupName }}
        </v-chip>
    </div>
</template>

<script>
    export default {

        props: ['group'],

        data() {
            return {}
        },

        computed: {
            groupName() {
                return this.group ? this.group.name:'';
            }
        },

        methods: {

        }
    }
</script>
